import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faAdjust, faFilm, faVideo } from '@fortawesome/free-solid-svg-icons';
import { VideoView } from 'src/app/@domain/video/entities/video-view.enum';

@Component({
    selector: 'app-video-view-picker',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FaIconComponent],
    styles: `
      @use "functions" as *;

      :host {
        background-color: #000027;
        display: flex;
        align-items: center;
      }

      .option {
        padding: 0.5rem 0.65rem;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        fa-icon {
          color: #fff;
        }

        &.active {
          background-color: rgba(177, 177, 177, 0.609);
        }

        @include break(768px) {
          padding: 0.25rem 0.35rem;

          fa-icon {
            font-size: 16px;
          }
        }

        @include break(450px) {
          fa-icon {
            font-size: 14px;
          }
        }
      }
    `,
    template: `
        <div class="option" [class.active]="currentView === View.Split" (click)="updateView(View.Split)">
            <fa-icon [icon]="faAdjust"/>
        </div>
        <div class="option" [class.active]="currentView === View.Video" (click)="updateView(View.Video)">
            <fa-icon [icon]="faVideo"/>
        </div>
        <div class="option" [class.active]="currentView === View.Presentation" (click)="updateView(View.Presentation)">
            <fa-icon [icon]="faFilm"/>
        </div>
    `
})
export class VideoViewPickerComponent {
    @Output() activeViewChange = new EventEmitter<VideoView>();
    @Input({ required: true }) currentView!: VideoView;
    public View = VideoView;
    public faFilm = faFilm;
    public faVideo = faVideo;
    public faAdjust = faAdjust;

    public updateView(view: VideoView): void {
        this.currentView = view;
        this.activeViewChange.emit(view);
    }
}
